import {FC} from "react";


export const AccordionArrow: FC<any> = ({size = 32}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6.5L8 10.5L4 6.5" stroke="#47A7FF" strokeWidth="1.6" strokeLinecap="round"/>
        </svg>
    )
}